export default __webpack_public_path__ + "76507bbd0ca00c3c4b329af0a7db7ea3.png";